import React from "react";
import PropTypes from "prop-types";
import { useField } from "formik";

function SelectField({ label, data = [], fullWidth, required, ...props }) {
  const [field, meta] = useField(props);
  const showError = meta.touched && meta.error;

  return (
    <div className={`mb-2 ${fullWidth ? "col-md-12" : "col-md-6"}`}>
      {label && (
        <label className="form-label fs-6 d-block" htmlFor={props.name}>
          {label}
          {required && <span className="text-danger">*</span>}
        </label>
      )}
      <select
        className={`form-select ${showError ? "is-invalid" : ""}`}
        id={props.name}
        {...field}
      >
        <option value="">Select an option</option>
        {data.map((item, index) => (
          <option key={index} value={item.value}>
            {item.label}
          </option>
        ))}
      </select>
      {showError && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  );
}

SelectField.propTypes = {
  label: PropTypes.string,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
    })
  ),
};

export default SelectField;
